import React from "react";
import tickIcon from "../../../assets/icons/tick-icon.svg";

const FeatureCard = ({ featuredCardData }) => {
  return (
    <div>
      <div className="flex md:flex-row flex-col md:justify-between justify-center md:items-start items-center gap-20 my-20">
        <div className="max-w-2xl flex flex-col gap-3">
          <p className="text-sm font-normal">{featuredCardData.subtitle}</p>
          <h1 className="text-4xl font-semibold">
            {featuredCardData.title}
          </h1>
          <p className="font-normal text-lg pr-10">
            {featuredCardData.description}
          </p>
        </div>

        <div className="bg-gradient-to-r from-[#8468B1] to-[#5A72EA] max-w-3xl w-full rounded-2xl p-10 text-white">
          <button className="border border-white py-2 px-5 rounded-2xl mb-4">
            features
          </button>
          <div className="flex gap-4 justify-between">
            <div className="pr-5">
              <p className="text-4xl font-semibold">
                {featuredCardData.featuredTitle}
              </p>
            </div>
            <div className="max-w-80">
              <div className="flex flex-col gap-3">
                {featuredCardData.features.map((feature) => (
                  <div className="flex items-start gap-2" key={feature.id}>
                    <div className="h-6 w-6">
                      <img
                        src={tickIcon}
                        alt="tickIcon"
                        className="h-full w-full"
                      />
                    </div>
                    <div className="">
                      <div className="font-bold">{feature.title}:</div>
                      <p className="font-normal">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
